import { LOCATIONSA_AUTOCOMPLETE } from 'src/modules/_global/js/_constants.js';

(function() {
    "use strict";
    /*
        This used jQueryValidation: https://jqueryvalidation.org/
    */

    const CheckboxMustSelectOneSelector = "input[data-checkbox-one-selected]";
    const DateDayMonthYearRequired =
        "select[data-date-day-month-year-required]";

    const MatrixDateTime = ".sq-form-question-datetime";
    const MatrixFormSubmit = ".sq-form-submit";

    const form = $("#online-portal-employer-form").closest("form");
    if (form) {
        form.validate({
            errorClass: "form__error",
            errorPlacement: function(error, element) {
                if (element.is('input[type="radio"], input[type="checkbox"')) {
                    error.insertAfter(
                        element.closest("fieldset").find("legend")
                    );
                } else if (element.is(DateDayMonthYearRequired)) {
                    error.insertAfter(
                        element.closest("fieldset").find("legend")
                    );
                } else {
                    error.insertAfter(element);
                }
            },
            groups: (function() {
                // Collect any form fields which should be grouped for error message purposes
                let groups = {};
                const dateTimes = form.find(MatrixDateTime);

                dateTimes.each((i, dateTime) => {
                    let fieldNames = "";
                    const selects = $(dateTime).find("select");
                    selects.each((i, select) => {
                        fieldNames += $(select).attr("name") + " ";
                    });

                    groups[`g${i}`] = fieldNames.trim();
                });

                return groups;
            })(),
        });

        $.validator.addMethod(
            "checkbox-one-selected",
            function(value, element) {
                const fieldset = $(element).closest("fieldset");
                return fieldset.find("input[type=checkbox]:checked").length > 0;
            },
            "You must select at least one"
        );
        $(CheckboxMustSelectOneSelector).each((i, element) => {
            $(element).rules("add", {
                "checkbox-one-selected": true,
            });
        });

        $.validator.addMethod(
            "date-day-month-year-required",
            function(value, element) {
                const fieldset = $(element).closest("fieldset");

                const year = parseInt(
                    fieldset.find('select[name$="[y]"] option:selected').val()
                );
                const month = parseInt(
                    fieldset.find('select[name$="[m]"] option:selected').val()
                );
                const day = parseInt(
                    fieldset.find('select[name$="[d]"] option:selected').val()
                );

                return !isNaN(year) && !isNaN(month) && !isNaN(day);
            },
            "Day, Month and Year are required"
        );
        $(DateDayMonthYearRequired).each((i, element) => {
            $(element).rules("add", {
                "date-day-month-year-required": true,
            });
        });

        form.find(MatrixFormSubmit).attr("disabled", false);

    }

    $("[data-location-autocomplete]").each((index, domNode) => {
        /* 
            When users select location, XHR request locationSA API and get lat/long coords
            Store values into hidden field on form 
        */
        const autocompleteOptions = {
            source: function(request, response) {
                $.ajax({
                    url: LOCATIONSA_AUTOCOMPLETE,
                    dataType: "json",
                    data: {
                        text: request.term
                    },
                    success: function(data) {
                        const transformData = data.features.map((item) => {
                            const { label, name, id } = item.properties
                            const newObj = {
                                label,
                                value: name,
                                id,
                                coordinates: item.geometry.coordinates
                            }
                            return newObj
                        })
                        response(transformData);
                    }
                });
            },
            select: function(event, ui) {
                // console.log(ui.item.coordinates)
                const geolcationInputData = [...ui.item.coordinates].reverse().join(';');
                $('[data-geolocation-field]').val(geolcationInputData)
            }
        }

        ;
        (function executeAutocomplete() {
            /* eslint-disable */
            if (typeof jqForMatrix === "function") {
                jqForMatrix(domNode).autocomplete(autocompleteOptions);
            } else {
                $(domNode).autocomplete(autocompleteOptions);
            }
        })();

    });
})();